"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorCollectionEditCtrl = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const modal_service_1 = require("../../components/modal/modal.service");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const theme_1 = require("../../components/theme");
const index_1 = require("../../i18n/index");
const collection_change_state_1 = require("../../modules/collection.view/collection.change.state");
const multi_list_chooser_1 = require("../../modules/multi.list.chooser/multi.list.chooser");
const multi_list_chooser_style_1 = require("../../modules/multi.list.chooser/multi.list.chooser.style");
const span_link_chooser_state_1 = require("../../modules/multi.list.chooser/span.link.chooser.state");
const point_collection_cache_1 = require("../../modules/topological.editor.map/point.collection.cache");
const services_1 = require("../../services");
const collection_edit_state_1 = require("../../state/collection.edit.state");
const mobx_2 = require("../../state/mobx");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
const upload_reader_1 = require("../../util/upload.reader");
class TopologicalEditorCollectionEditCtrl extends mobx_2.MobxState {
    constructor(collection, parentState) {
        super();
        this.isFormOpen = mobx_1.observable.map({}, { deep: false });
        this.isFieldDetailShown = mobx_1.observable.map({}, { deep: false });
        this.isCollectionLoading = false;
        this.isCollectionSelected = true;
        this.isAllExpanded = true;
        this.isInEditMode = false;
        this.isSaving = false;
        this.isMetadataShown = false;
        this.isZoomShown = true;
        this.isPhotomeasure = false;
        this.isTopologicalEditor = true;
        this.isCarouselShown = true;
        /** File upload */
        this.maxFileSize = 1024 * 1024 * 10; // 10 Megabyte
        this.allowedTypes = [];
        this.isInUploadMode = false;
        this.fieldsInLoadingState = [];
        this.file = null;
        this.image = null;
        this.kind = 'TopologicalEditorCollectionEditCtrl';
        this.collectionEditState = new collection_edit_state_1.CollectionEditState(collection);
        this.changeState = new collection_change_state_1.CollectionChangeState();
        this.parentState = parentState;
        this.reaction((_) => this.file && this.file.buffer, this.processFile);
        this.reaction((_) => this.image && this.image.buffer, this.processImage);
    }
    get collection() {
        return this.collectionEditState.collection;
    }
    get revision() {
        return this.collection.revision;
    }
    get id() {
        return this.collection.id;
    }
    get isEditing() {
        return this.changeState != null && (this.isInEditMode || this.isPhotomeasure || this.isTopologicalEditor);
    }
    get isValid() {
        return this.changeState != null && this.changeState.isValid && !this.isInUploadMode;
    }
    get isMeasurementActive() {
        return this.parentState.measurementState.isActive && !this.parentState.measurementState.isPaused;
    }
    get isRelocatePoleActive() {
        return this.parentState.isRelocatePoleActive;
    }
    get isEditable() {
        return services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_MODE);
    }
    get isUploading() {
        return this.changeState != null && this.isInUploadMode;
    }
    zoomToCollection() {
        //TODO: add zoom to collection
    }
    clearOpenState() {
        this.isFormOpen.clear();
        this.isFieldDetailShown.clear();
    }
    abortChanges(e) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            let shouldDiscard = false;
            try {
                shouldDiscard = yield this.checkAndDiscardChanges();
            }
            catch (error) {
                services_1.Services.Log.Logger.error(error, 'TE: Discard changes failed');
                notification_service_1.NotificationService.error({
                    key: index_1.T.ERROR_GENERAL,
                });
            }
            if (shouldDiscard && this.changeState != null) {
                this.discardAndDestroyEdit();
            }
            return false;
        });
    }
    selectAnchorField(e, field) {
        e.preventDefault();
        services_1.Services.Log.Logger.warn(`1. Anchor is edit by user ${services_1.Services.User.current.email.toString()} in department ${services_1.Services.Department.current.name.toString()} of organization ${services_1.Services.Department.currentOrg.name.toString()}`);
    }
    checkAndDiscardChanges() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield modal_service_1.ModalService.open({
                title: index_1.T.DISCARD_CHANGES_TITLE,
                content: (0, index_1.Translate)(index_1.T.DISCARD_CHANGES_CONFIRM),
                okName: index_1.T.DISCARD_CHANGES_DISCARD,
                hasCancel: true,
            });
            return response.ok;
        });
    }
    discardAndDestroyEdit() {
        if (this.changeState != null) {
            //discard everything
            while (this.collectionEditState.isDirty) {
                this.collectionEditState.reset();
            }
        }
        this.changeState = new collection_change_state_1.CollectionChangeState();
        this.isInEditMode = false;
        point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionLocations(this.revision);
        point_collection_cache_1.TopologicalPointCollectionCache.flushVectors();
    }
    saveChanges(e) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const changes = this.changeState;
            if (!changes || !this.changeState.isValid) {
                return;
            }
            if (!this.collectionEditState.isDirty) {
                return;
            }
            if (this.isSaving) {
                return;
            }
            const originalCollection = this.collection;
            const originalRevision = originalCollection.revision;
            const draw = this.collectionEditState.currentDraw;
            const drawState = draw != null ? draw.state : null;
            const wasNewPole = this.parentState.newPoleModel.some((pole) => pole.revision === originalRevision);
            this.setSaving(true);
            try {
                // Services.Collection.save() handles new collection summary creation, refreshing, and fetching
                const result = yield services_1.Services.Collection.save(originalCollection);
                // Remove from newPoleModel if it was a newly created pole
                if (wasNewPole) {
                    (0, mobx_1.runInAction)(() => {
                        const index = this.parentState.newPoleModel.findIndex((pole) => pole.revision === originalRevision);
                        if (index !== -1) {
                            this.parentState.newPoleModel.splice(index, 1);
                        }
                        this.parentState.removeEditController(originalRevision);
                    });
                }
                yield this.collectionCommitted(result, originalCollection, drawState);
                this.collectionEditState.reset();
                this.parentState.refreshOverlay();
                // Update selection to the new revision after everything is ready
                if (wasNewPole) {
                    this.parentState.setSelectedCollectionRevision(result.revision);
                }
            }
            catch (error) {
                this.setSaving(false);
                services_1.Services.Log.Logger.error(error);
                notification_service_1.NotificationService.error({
                    key: index_1.T.COLLECTION_EDIT_SAVE_ERROR,
                });
            }
        });
    }
    // This is a specific method for saving a collection as part of a batch edit
    // inside of a "job". It provides minimal error handling and state modification
    // with the expectation that error management and logging will be handled upstream.
    batchSaveChanges() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const changes = this.changeState;
            if (!changes || !this.changeState.isValid || !this.collectionEditState.isDirty || this.isSaving) {
                return null;
            }
            const originalCollection = this.collection;
            const originalRevision = originalCollection.revision;
            const wasNewPole = this.parentState.newPoleModel.some((pole) => pole.revision === originalRevision);
            this.setSaving();
            try {
                // Services.Collection.save() handles new collection summary creation, refreshing, and fetching
                const result = yield services_1.Services.Collection.save(originalCollection);
                this.setSaving(false);
                this.collectionEditState.reset();
                point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(originalRevision);
                // Remove from newPoleModel if it was a newly created pole
                if (wasNewPole) {
                    (0, mobx_1.runInAction)(() => {
                        const index = this.parentState.newPoleModel.findIndex((pole) => pole.revision === originalRevision);
                        if (index !== -1) {
                            this.parentState.newPoleModel.splice(index, 1);
                        }
                    });
                }
                return result;
            }
            catch (error) {
                // Chuck this error upstream to be handled by whatever
                // is calling the batched save
                throw error;
            }
            finally {
                this.setSaving(false);
            }
        });
    }
    setSaving(value = true) {
        this.isSaving = value;
    }
    collectionCommitted(collection, originalCollection, drawState) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { TimingEventType, TimingEventAction } = services_1.Services.Analytics;
            services_1.Services.Analytics.trackTiming(TimingEventType.TOPOLOGICAL_EDITOR, TimingEventAction.ENTER, originalCollection.id, new Date(this.changeState.startTime));
            services_1.Services.Analytics.trackTiming(TimingEventType.TOPOLOGICAL_EDITOR, TimingEventAction.EXIT, originalCollection.id, new Date());
            this.changeState.startTime = Date.now();
            (0, mobx_1.runInAction)(() => {
                // PM page will have an IkeDraw. The map page will not.
                if (this.collectionEditState.currentDraw != null) {
                    this.collectionEditState.currentDraw.state.setFromState(drawState);
                }
                this.setSaving(false);
            });
        });
    }
    toggleFieldDetail(fieldId) {
        if (this.isFieldDetailShown.get(fieldId)) {
            this.isFieldDetailShown.delete(fieldId);
        }
        else {
            this.isFieldDetailShown.set(fieldId, true);
        }
    }
    clearModalField(field) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield modal_service_1.ModalService.open({
                title: index_1.T.FILE_DELETE_TITLE,
                content: (0, index_1.Translate)(index_1.T.FILE_DELETE_MESSAGE, field.value),
                okName: index_1.T.FILE_DELETE,
                hasCancel: true,
            });
            if (response.ok) {
                field.Mutator.clear();
                const state = this.changeState.getState(field.id);
                if (state != null) {
                    state.setValue(null);
                }
            }
        });
    }
    clearField(field) {
        field.Mutator.clear();
        if (core_shared_1.CollectionModelFieldVector.isVectorField(field)) {
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(this.revision);
        }
        const state = this.changeState.getState(field.id);
        if (state != null) {
            state.setValue(null);
        }
    }
    toggleCarousel() {
        this.isCarouselShown = !this.isCarouselShown;
    }
    /**
     * File upload related functions
     */
    onDragOver(e, field) {
        e.preventDefault();
        const dragArea = document.getElementById(`drag-area-${field.id}`);
        if (dragArea == null) {
            return;
        }
        dragArea.style.backgroundColor = theme_1.DefaultTheme.color.accent;
    }
    onDragLeave(e, field) {
        e.preventDefault();
        const dragArea = document.getElementById(`drag-area-${field.id}`);
        if (dragArea == null) {
            return;
        }
        dragArea.style.backgroundColor = null;
    }
    onDragEnd(e, field) {
        e.preventDefault();
        const dragArea = document.getElementById(`drag-area-${field.id}`);
        if (dragArea == null) {
            return;
        }
        dragArea.style.backgroundColor = null;
    }
    openImageDialog(e, field) {
        e.preventDefault();
        const imageInput = document.getElementById(field.id);
        if (imageInput == null) {
            throw new Error('Unable to find file input: "' + field.id + "'");
        }
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        imageInput.dispatchEvent(evt);
    }
    openFileDialog(e, field) {
        e.preventDefault();
        const fileInput = document.getElementById(field.id);
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + field.id + "'");
        }
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        fileInput.dispatchEvent(evt);
    }
    onImage(e, field) {
        const imageInput = e.target;
        if (imageInput == null) {
            throw new Error(`Unable to find file input: "${field.id}"`);
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'image:click', 'button', 1);
        this.loadImages(imageInput.files, field);
    }
    onFile(e, field) {
        const fileInput = e.target;
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + field.id + "'");
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:click', 'button', 1);
        this.loadFiles(fileInput.files, field);
    }
    update(e, field) {
        e.preventDefault();
        if (e.dataTransfer == null) {
            return;
        }
        const files = e.dataTransfer.files;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:drop', 'drop', 1);
        this.loadFiles(files, field);
    }
    loadImages(images, field) {
        this.image = null;
        if (images && images[0]) {
            const image = images[0];
            const validationError = (0, upload_reader_1.validateImageFile)(image);
            if (validationError) {
                notification_service_1.NotificationService.error({ key: index_1.T[validationError] });
                this.unsetLoading(field.id);
                return;
            }
            this.image = new upload_reader_1.ImageUploadReader(image, field);
        }
    }
    loadFiles(files, field) {
        this.file = null;
        if (files == null) {
            return;
        }
        if (files.length > 1) {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:count', String(files.length), 1);
            notification_service_1.NotificationService.error({ key: index_1.T.FILE_NOT_SUPPORTED });
            this.unsetLoading(field.id);
            return;
        }
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (this.maxFileSize < file.size) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:large', 'large', file.size);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_TOO_LARGE });
                this.unsetLoading(field.id);
                continue;
            }
            const fileType = file.type.toLowerCase();
            if (this.allowedTypes.length > 0 && fileType !== '' && this.allowedTypes.indexOf(fileType) === -1) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:type', fileType, 1);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_NOT_SUPPORTED });
                this.unsetLoading(field.id);
                continue;
            }
            this.file = new upload_reader_1.FileUploadReader(file, field);
        }
    }
    processFile() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = this.file) === null || _a === void 0 ? void 0 : _a.buffer) {
                this.setLoading(this.file.field.id);
                const rest = services_1.Services.Department.rest;
                try {
                    const attachment = yield rest.Attachment.set(this.file.name, this.file.buffer, this.file.type);
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    rest.Attachment.virusScan(attachment.objectId);
                    let metadata = {};
                    try {
                        metadata = yield rest.Attachment.parse(attachment.objectId);
                    }
                    catch (error) {
                        services_1.Services.Log.Logger.info(`File cannot be parsed: ${error}`);
                    }
                    this.file.field.Mutator.manual({
                        filename: this.file.name,
                        attachmentId: attachment.objectId,
                        size: attachment.size,
                        metadata,
                    });
                }
                catch (_e) {
                    notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
                }
                this.unsetLoading(this.file.field.id);
            }
        });
    }
    processImage() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = this.image) === null || _a === void 0 ? void 0 : _a.buffer) {
                this.setLoading(this.image.field.id);
                const rest = services_1.Services.Department.rest;
                let capture = null;
                try {
                    capture = yield rest.Capture.Image.image(core_shared_1.IkeId.v4(), this.image.buffer, 1, new Date());
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    rest.Attachment.virusScan(capture.objectId);
                    this.image.field.Mutator.add(capture.objectId);
                }
                catch (e) {
                    notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
                    services_1.Services.Log.Logger.info(`Image cannot be parsed: ${e}`);
                }
                this.unsetLoading(this.image.field.id);
            }
        });
    }
    fileDownload(field) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (field.attachmentId) {
                this.setLoading(field.id);
                const token = `Bearer ${services_1.Services.SSO.token}`;
                const url = '/v1/file/' + field.attachmentId + '?departmentId=' + services_1.Services.Department.current.objectId;
                const options = {
                    headers: {
                        Authorization: token,
                    },
                };
                fetch(url, options)
                    .then((res) => {
                    if (!res.ok) {
                        services_1.Services.Log.Logger.error('File possibly infected');
                        notification_service_1.NotificationService.error({
                            key: index_1.T.ERROR_DOWNLOAD_FAIL,
                        });
                        return null;
                    }
                    return res.blob();
                })
                    .then((blob) => {
                    if (blob != null) {
                        var file = window.URL.createObjectURL(blob);
                        var link = services_1.Services.Window.document.createElement('a');
                        link.download = field.value;
                        link.href = file;
                        services_1.Services.Window.document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                    this.unsetLoading(field.id);
                })
                    .catch((e) => {
                    services_1.Services.Log.Logger.error(e, 'File download error');
                    notification_service_1.NotificationService.error({
                        key: index_1.T.ERROR_GENERAL,
                    });
                    this.unsetLoading(field.id);
                });
            }
            return false;
        });
    }
    setLoading(fieldId) {
        this.isInUploadMode = true;
        this.fieldsInLoadingState.push(fieldId);
    }
    unsetLoading(fieldId) {
        this.isInUploadMode = false;
        this.fieldsInLoadingState.splice(this.fieldsInLoadingState.indexOf(fieldId), 1);
    }
    /**
     * File upload related functions end
     */
    fillAddressDisabled(field) {
        if (field.value) {
            return true;
        }
        if (this.location() == null) {
            return true;
        }
        if (!this.isEditing || this.isSaving) {
            return true;
        }
        return false;
    }
    geocodingButtonTitle(field) {
        if (field.value) {
            return 'Already has value';
        }
        if (this.location() == null) {
            return 'There is no location';
        }
        return 'Get address';
    }
    location() {
        const revision = this.collection.revision;
        const collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
        if (collectionSummary == null) {
            return null;
        }
        const location = collectionSummary.location;
        if (!(location && location.coordinates)) {
            return null;
        }
        return location;
    }
    fillAddress(field) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const location = this.location();
            if (location == null) {
                return null;
            }
            const addressFields = yield services_1.Services.Geocoder.getAddress(location);
            const address = addressFields.address;
            const fieldState = this.changeState.getState(field.id);
            fieldState.setValue(address);
            if (address === (0, index_1.Translate)(index_1.T.ERROR_GENERAL)) {
                fieldState.setError(address);
            }
            const metadata = field.collection.schema.metadata;
            const city = addressFields.city;
            const state = addressFields.state;
            if (city && metadata.options.address_lookup.city) {
                const cityFieldId = metadata.options.address_lookup.city.field;
                const cityFieldState = this.changeState.getState(core_shared_1.CollectionModelField.getStateId(field.parent, cityFieldId));
                if (cityFieldState) {
                    cityFieldState.setValue(city);
                }
            }
            if (state && metadata.options.address_lookup.state) {
                const stateFieldId = metadata.options.address_lookup.state.field;
                const stateFieldState = this.changeState.getState(core_shared_1.CollectionModelField.getStateId(field.parent, stateFieldId));
                if (stateFieldState) {
                    stateFieldState.setValue(state);
                }
            }
        });
    }
    clearError(field) {
        const fieldState = this.changeState.getState(field.id);
        fieldState.setValue('');
        fieldState.setError('');
    }
    clearErrorDisabled(field) {
        if (!this.isEditing || this.isSaving) {
            return true;
        }
        const state = this.changeState.getState(field.id);
        if (state.hasError() === true) {
            return false;
        }
        return true;
    }
    isExpanded(instanceId) {
        if (this.isAllExpanded) {
            return this.isFormOpen.get(instanceId) !== false;
        }
        return this.isFormOpen.get(instanceId);
    }
    toggleExpanded(e, instanceId) {
        e.preventDefault();
        let prev = this.isFormOpen.get(instanceId);
        if (prev == null) {
            prev = this.isAllExpanded;
        }
        this.isFormOpen.set(instanceId, !prev);
        return false;
    }
    setZoomWindow(show) {
        this.isZoomShown = show;
    }
    toggleMetaInfo() {
        this.isMetadataShown = !this.isMetadataShown;
        this.isZoomShown = false;
    }
    toggleZoomWindow() {
        this.isZoomShown = !this.isZoomShown;
        this.isMetadataShown = false;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, `zoom:${this.isZoomShown ? 'show' : 'hide'}`, this.collection.revision);
    }
    toggleExpandAll() {
        this.isAllExpanded = !this.isAllExpanded;
        this.isFormOpen.clear();
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, `form:${this.isAllExpanded ? 'expand' : 'collapse'}`, this.collection.revision);
    }
    enterEditMode() {
        const collection = this.collection;
        if (collection != null) {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'Collection:edit', collection.uuid, 1);
        }
        this.isInEditMode = true;
    }
    exitEditMode() {
        if (this.collectionEditState.isDirty) {
            throw new Error('Must discard changes before exiting collection edit mode');
        }
        this.isInEditMode = false;
    }
    beginSpanLink(c) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const collection = c.collection;
            const state = new span_link_chooser_state_1.SpanLinkChooserState(collection);
            const result = yield modal_service_1.ModalService.open({
                title: multi_list_chooser_1.MultiListChooserTitle.view(state),
                content: () => multi_list_chooser_1.MultiListChooserContent.view(state),
                className: multi_list_chooser_style_1.CSS.modal,
                hasCancel: true,
            });
            if (!result.ok) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'span:link:cancel', this.collection.revision);
                return;
            }
            if (state.value == null) {
                state.selectDefaultValue();
            }
            const spanLinkRecord = state.getSelectedSpanLinkRecord();
            if (spanLinkRecord == null) {
                return;
            }
            (0, mobx_1.runInAction)(() => {
                try {
                    const newSubformInstance = services_1.Services.SubFormLink.copySubForm(collection, spanLinkRecord);
                    notification_service_1.NotificationService.success({
                        key: index_1.T.SPAN_LINK_SUCCESS,
                        attrs: {
                            toSpan: newSubformInstance.title,
                            fromCollection: spanLinkRecord.collection.title,
                        },
                    });
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'span:link', this.collection.revision);
                }
                catch (e) {
                    services_1.Services.Log.Logger.error(e, 'Span link failed');
                    notification_service_1.NotificationService.error({
                        key: index_1.T.ERROR_GENERAL,
                    });
                }
            });
        });
    }
    get matches() {
        if (!services_1.Services.Measurement.isFormSupported(this.collection.schema)) {
            return [];
        }
        return services_1.Services.Measurement.getFieldJoins(this.collection);
    }
    getJoin(field) {
        for (const match of this.matches) {
            const join = match.getJoin(field.parent.instanceId, field.schema.id);
            if (join != null) {
                return join;
            }
        }
        return null;
    }
    getOppositeJoin(field) {
        for (const match of this.matches) {
            const join = match.getOppositeJoin(field.parent.instanceId, field.schema.id);
            if (join != null) {
                return join;
            }
        }
        return null;
    }
    chooseLinkingCollection(field) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            page_state_1.CurrentState.CollectionLink.beginLinking(field.id);
            return new Promise((resolve) => {
                const disposer = (0, mobx_1.reaction)(() => page_state_1.CurrentState.CollectionLink.isLinking, () => {
                    disposer();
                    const revision = page_state_1.CurrentState.CollectionLink.collectionRevision;
                    if (revision == null) {
                        resolve(null);
                    }
                    const collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
                    if (collectionSummary == null) {
                        resolve(null);
                    }
                    resolve(collectionSummary);
                });
            });
        });
    }
    canInspectCollection(summary) {
        if (summary == null) {
            return false;
        }
        const tag = store_1.AppStore.Tag.get(summary.tags[0]);
        return services_1.Services.Search.includesTag(tag);
    }
    inspectCollection(revision) {
        this.parentState.setSelectedCollectionRevision(revision);
    }
    redrawMap() {
        this.parentState.map.overlay.resetMoveDelta();
    }
    get useColorCoding() {
        return false;
    }
}
exports.TopologicalEditorCollectionEditCtrl = TopologicalEditorCollectionEditCtrl;
tslib_1.__decorate([
    mobx_1.observable.ref
], TopologicalEditorCollectionEditCtrl.prototype, "changeState", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "isAllExpanded", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "isInEditMode", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "isSaving", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "isMetadataShown", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "isZoomShown", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "isPhotomeasure", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "isTopologicalEditor", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "isCarouselShown", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "isInUploadMode", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorCollectionEditCtrl.prototype, "fieldsInLoadingState", void 0);
tslib_1.__decorate([
    mobx_1.observable.shallow
], TopologicalEditorCollectionEditCtrl.prototype, "file", void 0);
tslib_1.__decorate([
    mobx_1.observable.shallow
], TopologicalEditorCollectionEditCtrl.prototype, "image", void 0);
tslib_1.__decorate([
    mobx_1.computed
], TopologicalEditorCollectionEditCtrl.prototype, "isMeasurementActive", null);
tslib_1.__decorate([
    mobx_1.computed
], TopologicalEditorCollectionEditCtrl.prototype, "isRelocatePoleActive", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "zoomToCollection", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "clearOpenState", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "abortChanges", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "selectAnchorField", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "discardAndDestroyEdit", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "saveChanges", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "batchSaveChanges", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "setSaving", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "toggleFieldDetail", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "clearModalField", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "clearField", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "toggleCarousel", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "onDragOver", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "onDragLeave", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "onDragEnd", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "openImageDialog", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "openFileDialog", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "onImage", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "onFile", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "update", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "processFile", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "processImage", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "fileDownload", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "fillAddress", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "clearError", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "toggleExpanded", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "setZoomWindow", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "toggleMetaInfo", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "toggleZoomWindow", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "toggleExpandAll", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorCollectionEditCtrl.prototype, "enterEditMode", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorCollectionEditCtrl.prototype, "exitEditMode", null);
tslib_1.__decorate([
    mobx_1.computed
], TopologicalEditorCollectionEditCtrl.prototype, "matches", null);
//# sourceMappingURL=topological.editor.collection.edit.ctrl.js.map